<div class="footer wrapper">
    <footer class="row">
        <div class="column small-12">
            <div class="container">
                <div class="icon icon-ship hide-for-medium-down"></div>
            </div>
        </div>
    </footer>
</div>
